import React from 'react';
import { Toolbar, ToolbarProps } from '@mui/material';

const sectionToolbarSx = {
    backgroundColor: '#fff',
    color: '#111827',
    fontWeight: 600,
    fontSize: '20px',
    minHeight: '50px',
    lineHeight: '50px',
    fontFamily: 'Poppins, Helvetica, Arial, sans-serif',
};

interface SectionToolbarProps extends Omit<ToolbarProps, 'style'> {
    children?: React.ReactNode;
    style?: React.CSSProperties;
}

const SectionToolbar = ({ children, style, sx, ...props }: SectionToolbarProps) => (
    <Toolbar sx={{ ...sectionToolbarSx, ...sx }} style={style} {...props}>
        {children}
    </Toolbar>
);

export default SectionToolbar;
